if (!customElements.get('carousel-scrollbar')) {
class CarouselScrollbar extends HTMLElement {
  connectedCallback() {
    this.trackId = this.getAttribute('track-id');
    this.track = document.getElementById(this.trackId);
    this.thumb = this.querySelector('.carousel-scrollbar__thumb');

    if (!this.track || !this.thumb) return;

    this.isDragging = false;
    this.startX = 0;

    this.updateScrollbarFn = this.updateScrollbar.bind(this);
    this.onMouseDownFn = this.onMouseDown.bind(this);
    this.onMouseMoveFn = this.onMouseMove.bind(this);
    this.onMouseUpFn = this.onMouseUp.bind(this);

    this.bindEvents();
    
    requestAnimationFrame(this.updateScrollbarFn);
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.updateScrollbarFn);
    this.resizeObserver?.disconnect();
    this.thumb?.removeEventListener('mousedown', this.onMouseDownFn);
    document.removeEventListener('mousemove', this.onMouseMoveFn);
    document.removeEventListener('mouseup', this.onMouseUpFn);
  }

  bindEvents() {
    this.track.addEventListener('scroll', this.updateScrollbarFn);
    
    this.resizeObserver = new ResizeObserver(this.updateScrollbarFn);
    this.resizeObserver.observe(this.track);

    this.thumb.addEventListener('dragstart', (e) => e.preventDefault());
    this.thumb.addEventListener('mousedown', this.onMouseDownFn);
    document.addEventListener('mousemove', this.onMouseMoveFn);
    document.addEventListener('mouseup', this.onMouseUpFn);
  }

  updateScrollbar() {
    const scrollWidth = this.track.scrollWidth;
    const clientWidth = this.track.clientWidth;
    
    if (clientWidth === 0 || scrollWidth === 0) return;

    const scrollLeft = this.track.scrollLeft;
    const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 10);
    
    // Si no hay scroll, ocultamos el componente entero
    if (scrollWidth <= clientWidth) {
      this.style.display = 'none';
      return;
    } else {
      this.style.display = 'block';
    }

    const maxScrollLeft = scrollWidth - clientWidth;
    const scrollPercentage = scrollLeft / maxScrollLeft;
    const maxThumbLeft = 100 - thumbWidth;
    const thumbLeft = scrollPercentage * maxThumbLeft;

    this.thumb.style.width = `${thumbWidth}%`;
    this.thumb.style.left = `${thumbLeft}%`;
  }

  onMouseDown(e) {
    this.isDragging = true;
    this.startX = e.clientX - this.thumb.getBoundingClientRect().left;
    document.body.style.userSelect = 'none';
    this.track.style.scrollBehavior = 'auto';
    this.track.style.scrollSnapType = 'none';
  }

  onMouseMove(e) {
    if (!this.isDragging) return;
    
    const scrollbarWidth = this.clientWidth;
    const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
    
    const thumbWidthPx = (parseFloat(this.thumb.style.width) / 100) * scrollbarWidth;
    const maxThumbLeftPx = scrollbarWidth - thumbWidthPx;
    
    let x = e.clientX - this.getBoundingClientRect().left - this.startX;
    x = Math.max(0, Math.min(x, maxThumbLeftPx));

    const scrollPercentage = x / maxThumbLeftPx;
    this.track.scrollLeft = scrollPercentage * maxScrollLeft;
  }

  onMouseUp() {
    if (this.isDragging) {
      this.isDragging = false;
      document.body.style.userSelect = '';
      this.track.style.scrollBehavior = '';
      this.track.style.scrollSnapType = '';
    }
  }
}

customElements.define('carousel-scrollbar', CarouselScrollbar);
}